import React from 'react'
import GlobalStorage from '../storage/GlobalStorage'

import HomeMain from './HomeMain'
import StoryMain from './StoryMain'
import StoryListMain from './StoryListMain'
import StoryEpisodeMain from './StoryEpisodeMain'
import FaqMain from './FaqMain'
import StoryEpisodeHTML from './StoryEpisodeHTML'



export default class extends React.Component{

  constructor(props)
  {
    super(props);    
    this.state = {
      currentMain: "Home"
    }
    this.switchMain = this.switchMain.bind(this);
    this.GS = new GlobalStorage();
  }

  componentDidMount() {
    //this.props.setMenu(this.switchMain);
 }

  switchMain(status) {
    this.setState({
      currentMain: status
    });
 }
  
  
  render()
  {
    return (
        <div>
           {   
            this.state.currentMain =="Home" ? (
              <HomeMain toggleModalState={this.props.toggleModalState} toggleModal={this.props.toggleModal} switchMain={this.props.switchMain} switchMenu={this.props.switchMenu}></HomeMain>
            ) : (
              null
            )
          }
          {   
            this.state.currentMain =="Story" ? (
              <StoryMain toggleModalState={this.props.toggleModalState} toggleModal={this.props.toggleModal} switchMain={this.props.switchMain} switchMenu={this.props.switchMenu}></StoryMain>
            ) : (
              null
            )
          }
          {   
            this.state.currentMain =="StoryList" ? (
              <StoryListMain toggleModalState={this.props.toggleModalState} toggleModal={this.props.toggleModal} switchMain={this.props.switchMain} switchMenu={this.props.switchMenu}></StoryListMain>
            ) : (
              null
            )
          }
          {   
            this.state.currentMain =="StoryEpisode" ? (
              <StoryEpisodeMain></StoryEpisodeMain>
            ) : (
              null
            )
          }
          {   
            this.state.currentMain =="StoryEpisodeHTML" ? (
              <StoryEpisodeHTML toggleModalState={this.props.toggleModalState} toggleModal={this.props.toggleModal} switchMain={this.props.switchMain} switchMenu={this.props.switchMenu}></StoryEpisodeHTML>
            ) : (
              null
            )
          }                     
          {   
            this.state.currentMain =="FAQ" ? (
              <FaqMain></FaqMain>
            ) : (
              null
            )
          }                     
        </div>
    )
  }
}